import React from 'react';
import PropTypes from 'prop-types';
import BoxedItem from '../boxed-item';

import './payments.scss';

const Unhandled = (props) => {
  const subtitle = props.active ? 'Indica con che importo pagherai' : '';
  return (
    <div className="unhandled">
      <BoxedItem
        title="Paga in contanti"
        subtitle={subtitle}
        icon="bi_ecommerce-cash-a"
        className="paymentTypeBox"
        active={props.active}
        onClick={props.onSelect}
      >
        {props.active &&
          <div className="unhandled__content">
            <select value={props.currentValue} onChange={(evt) => props.onSelect(evt.target.value)}>
              {props.values.map(val =>
                <option key={val.value} value={val.value}>{val.label}</option>)
              }
            </select>
          </div>
        }
      </BoxedItem>
    </div>
  );
};
Unhandled.propTypes = {
  active: PropTypes.bool,
  values: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
  })).isRequired,
  onSelect: PropTypes.func.isRequired,
  currentValue: PropTypes.number,
};

export default Unhandled;



// WEBPACK FOOTER //
// ./src/components/payment/unhandled.js